/**
 * A one-way channel from the pricing cards to the contact form.
 *
 * Clicking the Custom plan's "Contact us" should drop the visitor onto the
 * contact form with the subject already filled in, so a pricing/hosting enquiry
 * arrives labelled instead of blank. Pricing and Contact are independent
 * siblings on the landing page with no shared parent state, so they talk through
 * a window event rather than threading a prop through everything between them.
 *
 * Deliberately tiny and fire-and-forget: if the contact form is not mounted
 * (some other page), the event simply goes unheard, which is the correct
 * no-op — there is nothing to prefill.
 */
export const CONTACT_SUBJECT_EVENT = "easyplanner:contact-subject";

/** Ask the contact form, if present, to preload `subject`. */
export const requestContactSubject = (subject) => {
  window.dispatchEvent(
    new CustomEvent(CONTACT_SUBJECT_EVENT, { detail: subject }),
  );
};
